module.exports = __webpack_public_path__ + "img/spinner-animated.77f5386a.svg";